import React, { Fragment, useMemo, useState } from "react";
import Build from "@material-ui/icons/Build";
import { Dialog } from "@material-ui/core";
import Joi from "joi-browser";

import { ReportLink } from "./ReportLink";
import { ActionButtons, FormGrid, FormikForm } from "../../../forms";
import customParamsFieldsFactory from "./customParamsFieldsFactory";
import ModalTitle from "../../../layout/AppLayout/ModalDialog/ModalTitle";
import { DefaultContent } from "../../../layout/AppLayout/ModalDialog/components";
import RegularText from "../../../ui/Typography/RegularText";
import { useTimezone } from "../../../../contexts/TimezoneContext";

const CustomParamsReportLink = ({
  projectReport,
  handleDownloadReport,
  loading,
}) => {
  const [isOpen, setOpen] = useState(false);
  const timezone = useTimezone();

  const handleClick = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const handleSubmit = values => {
    closeDialog();
    handleDownloadReport({ ...projectReport, customParams: values }, "xls");
  };

  const { customParamsJson } = projectReport;

  const validationSchema = useMemo(() => {
    const keys = {};
    Object.values(customParamsJson).forEach(({ type, name, required }) => {
      keys[name] = Joi[type]().required(required);
    });
    return Joi.object().keys(keys);
  }, [customParamsJson]);

  return (
    <Fragment>
      <ReportLink
        {...projectReport}
        label="Build"
        Icon={Build}
        onClick={handleClick}
        loading={loading}
      />
      <Dialog open={isOpen}>
        <ModalTitle
          title={`${projectReport.name} - Report Parameters`}
          closeModalDialog={closeDialog}
        />
        <DefaultContent>
          <RegularText style={{ padding: "24px" }}>
            Fill in the following parameters to generate the report
          </RegularText>
        </DefaultContent>
        <FormikForm onSubmit={handleSubmit} validationSchema={validationSchema}>
          {formikProps => (
            <Fragment>
              <FormGrid
                fields={customParamsFieldsFactory(customParamsJson, timezone)}
                values={formikProps.values}
                {...formikProps}
              />
              <ActionButtons
                onSend={formikProps.handleSubmit}
                sendButtonText="Generate XLSX"
                isModal={true}
                onCancel={closeDialog}
              />
            </Fragment>
          )}
        </FormikForm>
      </Dialog>
    </Fragment>
  );
};

export default CustomParamsReportLink;
